module.exports = __webpack_public_path__ + "static/img/12.006306db.png";